/*
 * @Author: edvardchen
 * @Date:   2017-05-03 14:22:39
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:35:59
 */

// @flow
// import Modal from 'react-modal';
import React from 'react';
import { listen } from 'fbjs/lib/EventListener';

import styles from './index.scss';

import AsyncBundle from '../../components/AsyncBundle';

const load = () =>
  import(/* webpackChunkName: "reactModal" */ 'react-modal').then((_Modal) => {
    const Modal = _Modal.default;
    Modal.setAppElement(document.body);
    listen(document.body, 'touchmove', (e) => {
      const { className } = document.body || {};
      if (className.indexOf('ReactModal__Body--open') > -1) {
        e.preventDefault();
      }
    });
    return Modal;
  });

// eslint-disable-next-line react/display-name
export default (props: *) => (
  <AsyncBundle load={load}>
    {(Modal) => (
      <Modal
        overlayClassName={styles.overlay}
        className={styles.modal}
        parentSelector={() => document.getElementById('react-root') || document.body}
        {...props}
      />
    )}
  </AsyncBundle>
);
